/*
 * duo-fidget-catalog.js  —  Duo Gift Arcade fidget catalog (auto-generated)
 * Source: live `magnetic-fidget-toys` collection (products.json), 2026-06-20.
 * Owner edits: 3 multi-item sets removed (covered by singles); axolotl split
 * into separate Pink + Blue gems (real product color variants).
 *
 * Pure data. Browser (window.DuoFidgetCatalog) + Node (module.exports). Every
 * entry is a board gem: a cut-out packaging card in `tile`, add-to-cart by
 * `variantId`, grouped by interest `cluster` for the discovery recommender.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.DuoFidgetCatalog = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';
  var FIDGETS = [
  {
    "id": "taco-magnetic-fidget",
    "title": "Taco Magnetic Fidget",
    "short": "Taco",
    "handle": "taco-magnetic-fidget-coworker-desk-gift",
    "productId": "7987485900848",
    "variantId": "43263259410480",
    "price": "14.98",
    "available": true,
    "cluster": "foodie",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-taco-magnetic-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8098469168_leh7.jpg?v=1780618144"
  },
  {
    "id": "pizza-please-magnetic-fidget",
    "title": "Pizza Please Magnetic Fidget",
    "short": "Pizza Please",
    "handle": "pizza-magnetic-fidget-foodie-stress-relief-gift",
    "productId": "7996714680368",
    "variantId": "43300475895856",
    "price": "14.98",
    "available": true,
    "cluster": "foodie",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-pizza-please-magnetic-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8177855595_e9wv.jpg?v=1781405777"
  },
  {
    "id": "mama-bear-magnetic-fidget",
    "title": "Mama Bear Magnetic Fidget",
    "short": "Mama Bear",
    "handle": "mama-bear-magnetic-fidget-bear-paw-mom-gift",
    "productId": "7996714614832",
    "variantId": "43300475797552",
    "price": "14.98",
    "available": true,
    "cluster": "bears-parents",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-mama-bear-magnetic-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8126504240_oi9e_2c9a000e-a4c4-42ca-a674-79b588670016.jpg?v=1781405587"
  },
  {
    "id": "papa-bear-magnetic-fidget",
    "title": "Papa Bear Magnetic Fidget",
    "short": "Papa Bear",
    "handle": "papa-bear-magnetic-fidget-dad-desk-gift",
    "productId": "7996714549296",
    "variantId": "43300475600944",
    "price": "14.98",
    "available": true,
    "cluster": "bears-parents",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-papa-bear-magnetic-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8174270807_45u6.jpg?v=1781405501"
  },
  {
    "id": "donut-delight-sensory-fidget",
    "title": "Donut Delight Sensory Fidget",
    "short": "Donut Delight",
    "handle": "donut-sensory-fidget-cute-stress-relief-desk-gift",
    "productId": "7996714352688",
    "variantId": "43300475338800",
    "price": "14.98",
    "available": true,
    "cluster": "foodie",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-donut-delight-sensory-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8170246495_nytj.jpg?v=1781405391"
  },
  {
    "id": "axolotl-pink",
    "title": "Axolotl Love (Pink)",
    "short": "Pink Axolotl",
    "handle": "axolotl-fidget-toy-cute-sensory-desk-gift",
    "productId": "7996714221616",
    "variantId": "43300472062000",
    "price": "14.98",
    "available": true,
    "cluster": "whimsy",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-axolotl-pink.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8170073625_nlb7.jpg?v=1781405114"
  },
  {
    "id": "axolotl-blue",
    "title": "Axolotl Love (Blue)",
    "short": "Blue Axolotl",
    "handle": "axolotl-fidget-toy-cute-sensory-desk-gift",
    "productId": "7996714221616",
    "variantId": "43300472094768",
    "price": "14.98",
    "available": true,
    "cluster": "whimsy",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-axolotl-blue.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8170073627_l2vb.jpg?v=1781405114"
  },
  {
    "id": "dachshund-darling-magnetic-fidget",
    "title": "Dachshund Darling Magnetic Fidget",
    "short": "Dachshund Darling",
    "handle": "dachshund-magnetic-fidget-wiener-dog-desk-gift",
    "productId": "7996714188848",
    "variantId": "43300471963696",
    "price": "14.98",
    "available": true,
    "cluster": "dogs",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-dachshund-darling-magnetic-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8110267084_hg1j.jpg?v=1781404962"
  },
  {
    "id": "orange-spritz-unwind-fidget-magnet",
    "title": "Orange Spritz & Unwind Fidget Magnet",
    "short": "Orange Spritz & Unwind",
    "handle": "orange-spritz-fidget-magnet-cocktail-lover-gift",
    "productId": "7996714025008",
    "variantId": "43300471636016",
    "price": "14.98",
    "available": true,
    "cluster": "drinks",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-orange-spritz-unwind-fidget-magnet.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8181824211_qirq.jpg?v=1781404605"
  },
  {
    "id": "espresso-martini-fidget",
    "title": "Espresso Martini Fidget",
    "short": "Espresso Martini",
    "handle": "espresso-martini-fidget-cocktail-desk-gift",
    "productId": "7996713893936",
    "variantId": "43300471341104",
    "price": "14.98",
    "available": true,
    "cluster": "drinks",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-espresso-martini-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8133835758_h7mn.jpg?v=1781404477"
  },
  {
    "id": "boo-bliss-ghost-magnetic-fidget",
    "title": "Boo Bliss Ghost Magnetic Fidget",
    "short": "Boo Bliss Ghost",
    "handle": "ghost-magnetic-fidget-spooky-halloween-desk-gift",
    "productId": "7996713828400",
    "variantId": "43300471210032",
    "price": "14.98",
    "available": true,
    "cluster": "spooky-funny",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-boo-bliss-ghost-magnetic-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8181489229_aslt.jpg?v=1781404278"
  },
  {
    "id": "chalk-it-out-true-crime-magnetic-fidget",
    "title": "Chalk It Out True Crime Magnetic Fidget",
    "short": "Chalk It Out True Crime",
    "handle": "true-crime-magnetic-fidget-mystery-reader-gift",
    "productId": "7996713697328",
    "variantId": "43300469211184",
    "price": "14.98",
    "available": true,
    "cluster": "true-crime",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-chalk-it-out-true-crime-magnetic-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8130500340_b7k2.jpg?v=1781404123"
  },
  {
    "id": "killer-calm-true-crime-magnetic-fidget",
    "title": "Killer Calm True Crime Magnetic Fidget",
    "short": "Killer Calm True Crime",
    "handle": "true-crime-magnetic-fidget-podcast-fan-gift",
    "productId": "7996713599024",
    "variantId": "43300469014576",
    "price": "14.98",
    "available": true,
    "cluster": "true-crime",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-killer-calm-true-crime-magnetic-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8130208560_hx8e.jpg?v=1781403947"
  },
  {
    "id": "reel-relief-fish-fidget",
    "title": "Reel Relief Fish Fidget",
    "short": "Reel Relief Fish",
    "handle": "fish-magnetic-fidget-fishing-stress-relief-gift",
    "productId": "7996713566256",
    "variantId": "43300468981808",
    "price": "14.98",
    "available": true,
    "cluster": "outdoors",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-reel-relief-fish-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8129508884_ihum.jpg?v=1781403831"
  },
  {
    "id": "lighter-days-fidget",
    "title": "Lighter Days Fidget",
    "short": "Lighter Days",
    "handle": "magnetic-lighter-fidget-tie-dye-stress-relief-gift",
    "productId": "7996713467952",
    "variantId": "43300466720816",
    "price": "14.98",
    "available": true,
    "cluster": "whimsy",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-lighter-days-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8174720785_g8xq.jpg?v=1781403729"
  },
  {
    "id": "pickle-please-magnetic-fidget",
    "title": "Pickle Please Magnetic Fidget",
    "short": "Pickle Please",
    "handle": "pickle-magnetic-fidget-funny-stress-relief-gift",
    "productId": "7996713336880",
    "variantId": "43300466491440",
    "price": "14.98",
    "available": true,
    "cluster": "foodie",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-pickle-please-magnetic-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8122587900_h99x.jpg?v=1781403613"
  },
  {
    "id": "egg-magnetic-fidget",
    "title": "Egg Magnetic Fidget",
    "short": "Egg",
    "handle": "egg-magnetic-fidget-funny-foodie-desk-gift",
    "productId": "7996713205808",
    "variantId": "43300465147952",
    "price": "14.98",
    "available": true,
    "cluster": "foodie",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-egg-magnetic-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8173143605_mnp2.jpg?v=1781403372"
  },
  {
    "id": "bacon-bliss-sensory-fidget",
    "title": "Bacon Bliss Sensory Fidget",
    "short": "Bacon Bliss",
    "handle": "bacon-sensory-fidget-funny-foodie-desk-gift",
    "productId": "7996713074736",
    "variantId": "43300463476784",
    "price": "14.98",
    "available": true,
    "cluster": "foodie",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-bacon-bliss-sensory-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8124981896_4t11.jpg?v=1781403223"
  },
  {
    "id": "hot-sauce-fidget-magnet",
    "title": "Hot Sauce Fidget Magnet",
    "short": "Hot Sauce",
    "handle": "hot-sauce-fidget-magnet-spicy-desk-stress-relief-gift",
    "productId": "7996712976432",
    "variantId": "43300463312944",
    "price": "14.98",
    "available": true,
    "cluster": "foodie",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-hot-sauce-fidget-magnet.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8122671718_9ott.jpg?v=1781403132"
  },
  {
    "id": "leaf-it-be-monstera-leaf-fidget",
    "title": "Leaf It Be Monstera Leaf Fidget",
    "short": "Leaf It Be Monstera Leaf",
    "handle": "monstera-leaf-fidget-plant-lover-stress-relief-gift",
    "productId": "7996712615984",
    "variantId": "43300459053104",
    "price": "14.98",
    "available": true,
    "cluster": "plants",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-leaf-it-be-monstera-leaf-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8118226808_og0c.jpg?v=1781402796"
  },
  {
    "id": "bloom-breath-flower-magnetic-fidget",
    "title": "Bloom & Breath Flower Magnetic Fidget",
    "short": "Bloom & Breath Flower",
    "handle": "flower-magnetic-fidget-cottagecore-desk-gift",
    "productId": "7996712419376",
    "variantId": "43300457840688",
    "price": "14.98",
    "available": true,
    "cluster": "plants",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-bloom-breath-flower-magnetic-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8118090530_4nrr.jpg?v=1781402687"
  },
  {
    "id": "wish-upon-a-star-magnetic-fidget",
    "title": "Wish Upon a Star Magnetic Fidget",
    "short": "Wish Upon a Star",
    "handle": "star-magnetic-fidget-cute-sensory-desk-gift",
    "productId": "7996712386608",
    "variantId": "43300457807920",
    "price": "14.98",
    "available": true,
    "cluster": "whimsy",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-wish-upon-a-star-magnetic-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8161817875_im5e.jpg?v=1781402585"
  },
  {
    "id": "mushroom-magic-magnetic-fidget",
    "title": "Mushroom Magic Magnetic Fidget",
    "short": "Mushroom Magic",
    "handle": "mushroom-magnetic-fidget-cottagecore-desk-gift",
    "productId": "7996711403568",
    "variantId": "43300447420464",
    "price": "14.98",
    "available": true,
    "cluster": "plants",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-mushroom-magic-magnetic-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8165919007_icmp.jpg?v=1781401236"
  },
  {
    "id": "cat-paw-magnetic-fidget",
    "title": "Cat Paw Magnetic Fidget",
    "short": "Cat Paw",
    "handle": "cat-paw-magnetic-fidget-pink-paw-cat-lover-gift",
    "productId": "7996695806000",
    "variantId": "43300349378608",
    "price": "14.98",
    "available": true,
    "cluster": "cats",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-cat-paw-magnetic-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8113684348_chdl.jpg?v=1781390243"
  },
  {
    "id": "dog-paw-fidget-magnet",
    "title": "Dog Paw Fidget Magnet",
    "short": "Dog Paw",
    "handle": "dog-paw-fidget-magnet-stress-relief-desk-gift",
    "productId": "7996694855728",
    "variantId": "43300329422896",
    "price": "14.98",
    "available": true,
    "cluster": "dogs",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-dog-paw-fidget-magnet.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8114081750_og3k.jpg?v=1781390160"
  },
  {
    "id": "chasing-rainbow-magnetic-fidget",
    "title": "Chasing Rainbow Magnetic Fidget",
    "short": "Chasing Rainbow",
    "handle": "rainbow-magnetic-fidget-colorful-stress-relief-gift",
    "productId": "7996661956656",
    "variantId": "43300237279280",
    "price": "14.98",
    "available": true,
    "cluster": "whimsy",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-chasing-rainbow-magnetic-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8161914925_7jco.jpg?v=1781377609"
  },
  {
    "id": "tuxedo-kitty-cat-magnetic-fidget",
    "title": "Tuxedo Kitty Cat Magnetic Fidget",
    "short": "Tuxedo Kitty Cat",
    "handle": "tuxedo-cat-magnetic-fidget-sensory-desk-gift",
    "productId": "7996660514864",
    "variantId": "43300234199088",
    "price": "14.98",
    "available": true,
    "cluster": "cats",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-tuxedo-kitty-cat-magnetic-fidget.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8157872443_dg60.jpg?v=1781376885"
  },
  {
    "id": "dumpster-fire-fidget-magnet",
    "title": "Dumpster Fire Fidget Magnet",
    "short": "Dumpster Fire",
    "handle": "dumpster-fire-fidget-magnet-funny-coworker-gift",
    "productId": "7989115125808",
    "variantId": "43269420613680",
    "price": "14.98",
    "available": true,
    "cluster": "spooky-funny",
    "gem": true,
    "isSet": false,
    "tile": "arcade-fidget-dumpster-fire-fidget-magnet.webp",
    "photo": "https://cdn.shopify.com/s/files/1/0619/4731/4224/files/il_fullxfull.8151343443_j2c8.jpg?v=1780758522"
  }
];
  var CLUSTER_LABELS = {
  "foodie": "Foodie",
  "drinks": "Cocktail Lover",
  "cats": "Cat Lover",
  "dogs": "Dog Lover",
  "bears-parents": "Parent",
  "plants": "Plant Lover",
  "spooky-funny": "Spooky",
  "true-crime": "True Crime",
  "outdoors": "Outdoorsy",
  "whimsy": "Feel-Good"
};
  return { fidgets: FIDGETS, clusterLabels: CLUSTER_LABELS };
});
